var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._b({staticClass:"date-container",domProps:{"innerHTML":_vm._s(_vm.formatted)}},'span',_vm.config.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }